import { Button, Layout, Menu } from "antd";
import React, { useLayoutEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import "./style.css";
// import { images } from "../constants";
// import logo from "../assets/logo.jpg";
import logo from "../assets/sargLogo.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNewspaper } from "@fortawesome/free-regular-svg-icons";
import {
  faArrowsToEye,
  faCartPlus,
  faPercent,
  faShop,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { reduxLogout } from "../redux/Slices/authSlice";

const { Content, Footer, Sider } = Layout;

document.body.dir = "ltr";

const sidebarTabs = [
  {
    key: "banners",
    label: "Banners",
    icon: <FontAwesomeIcon icon={faShop} />,
  },
  {
    key: "users",
    label: "Users",
    icon: <FontAwesomeIcon icon={faUserGroup} />,
  },
  {
    key: "category",
    label: "Products",
    icon: <FontAwesomeIcon icon={faShop} />,
  },
  {
    key: "PhotoSliders",
    label: "Slider Photos",
    icon: <FontAwesomeIcon icon={faShop} />,
  },
  {
    key: "articles",
    label: "Articles",
    icon: <FontAwesomeIcon icon={faNewspaper} />,
  },
  {
    key: "news",
    label: "News",
    icon: <FontAwesomeIcon icon={faUserGroup} />,
  },
  {
    key: "about",
    label: "About",
    icon: <FontAwesomeIcon icon={faShop} />,
  },
  {
    key: "AddSlider",
    label: "slider title",
    icon: <FontAwesomeIcon icon={faArrowsToEye} />,
  },
  {
    key: "jobs",
    label: "Jobs",
    icon: <FontAwesomeIcon icon={faUserGroup} />,
  },
  {
    key: "jobRequests",
    label: "Job Requests",
    icon: <FontAwesomeIcon icon={faUserGroup} />,
  },
];

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((st) => st.auth);

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated]);

  const handleTabClick = (event) => {
    const clickedTabKey = event.key;
    navigate(`/dashboard/${clickedTabKey}`);
  };
  const handleLogout = () => {
    localStorage.removeItem("unitedUserToken");
    dispatch(reduxLogout());
  };
  return (
    <Layout className="dashboard" hasSider>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(broken) => {}}
        onCollapse={(collapsed, type) => {}}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <div
          className="logo mb-2"
          style={{ color: "white", cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <img src={logo} alt="logo" style={{ width: "100%" }} />
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["users"]}
          items={sidebarTabs}
          onClick={handleTabClick}
        />
        <div
          style={{
            position: "absolute",
            bottom: "1rem",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            type="primary"
            style={{ width: "80%" }}
            onClick={handleLogout}
          >
            logout
          </Button>
        </div>
      </Sider>
      <Layout
        style={{
          marginLeft: 200,
        }}
      >
        <Content
          style={{
            margin: "0 16px 0",
          }}
        >
          <div className="site-layout-background content">
            <Outlet />
          </div>
        </Content>
        <Footer
          style={{
            textAlign: "center",
          }}
        >
          prosoft
        </Footer>
      </Layout>
    </Layout>
  );
};
export default Dashboard;
